<template>
  <div>
    <Jumbotron title="" />

    <!-- dekstop -->
    <b-container class="d-none d-sm-block" style="margin-top: -75px;">
      <b-row class="m-3 p-4 sg-rounded-container">
        <b-col cols="12">
          <h1>Tempat-tempat Menyeramkan Di Eropa</h1>
        </b-col>

        <b-col class="text-center">
          <p class="mt-3 text-justify">
            &emsp;Jika kita berbicara tentang tempat seram, maka tidak akan pernah ada habisnya. Selalu ada saja tempat-tempat yang sarat dengan misteri dan ceritanya sendiri. Mitos dan sejarah kelam yang telah beredar di kalangan masyarakat pun membuat tempat-tempat ini semakin membuat tempat ini semakin terasa menyeramkan.
          </p>
          <p class="mt-3 text-justify">
            &emsp;Berikut ini StarGuides akan memberikan beberapa lokasi mengerikan yang ada di Eropa:
          </p>

          <h3 class="text-left">1.  Les Catacombes, Paris</h3>
          <b-img :src="require('@/assets/img/articles/191017/Picture1.jpg')" class="content-picture" style="max-width: 70%;" />
          <p class="mt-4 text-justify">
            &emsp;Siapa sangka di balik indahnya dan terkenalnya Paris sebagai pusat rumah mode di dunia ini ternyata kota ini menyimpan satu tempat menyeramkan yang tidak banyak orang tahu. Di bagian selatan kota, terdapat kuburan bawah tanah yang luasnya sekitar 300 meter dan terbesar di dunia yang menyimpan sekitar 6 juta tengkorak manusia yang disusun dengan rapih. Pada tahun 1800an salah satu pemakaman umum Les Innocents di tengah kota Paris sudah penuh dan mulai menyebarkan penyakit, sejak saat itu orang-orang meminta pemakaman untuk dipindahkan ke bawah tanah. Kemudian pada tahun 1900an tempat ini dibuka untuk umum dan menjadi tempat wisata baru bagi pecinta horror.
            </p>

          <h3 class="text-left">2.  Blutgasse, Vienna</h3>
          <b-img :src="require('@/assets/img/articles/191017/Picture2.jpg')" class="content-picture" style="max-width: 70%;" />
          <p class="mt-4 text-justify">
            &emsp;Di belakang Saint Stephen’s Cathedral, daerah tertua di kota Vienna, terdapat satu gang kecil bernama Blutgasse. “Blut” yang berarti darah, dan “Gasse” yang berarti gang dalam Bahasa Jerman. Tempat ini dijuluki Blutgasse karna dulunya mempunyai banyak sejarah seram salah satunya tentang dibunuhnya nya para Ksatria Templar pada tahun 1312 hingga darah pun memenuhi lokasi itu sampai gang ini menjadi salah satu jalan yang harus dilewati oleh para terpidana mati sebelum mereka di eksekusi. Meskipun gang ini berada di pusat kota, namun gang ini sangat sepi oleh pejalan kaki. Hal ini dikarenakan sejarah kelamnya yang membuat tempat ini enggan untuk dikunjungi.  Konon menurut laporan para warga sekitar mereka pernah melihat penampakan para Ksatria ini berjalan di malam hari.
            </p>

          <h3 class="text-left">3.  Bran Castle, Rumania</h3>
          <b-img :src="require('@/assets/img/articles/191017/Picture3.jpg')" class="content-picture" style="max-width: 70%;" />
          <p class="mt-4 text-justify">
            &emsp;Rumania juga mempunyai satu destinasi horror yang menjadi tujuan para wisatawan. Berada di Transylvania, terdapat satu istana yang sangat terkenal dan menjadi inspirasi nya cerita drakula bernama Bran Castle. Siapa yang tidak tahu tentang kisah drakula? Vampire yang suka menghisap darah manusia ini mengambil inspirasi dari tempat ini. Ditempati oleh raja Vlad III pada tahun 1400an, dia disebut sebagai raja Vlad Tepes atau Vlad Dracula yang artinya Vlad Sang Penyula. Ia sempat menjadi pahlawan yang berhasil melindungi Rumania dari pasukan Turki, namun ia juga menjadi raja yang sangat sadis pada masanya karna dia mempunyai hobi yang sangat mengerikan. raja Vlad ini senang untuk membunuh orang-orang yang menentangnya dengan cara disula, atau menusukkan kayu yang tajam dari ujung bawah badan korban hingga menembus keatas. Oleh karna cerita nya yang sadis ini menjadi awal mula cerita drakula.
            </p>

          <h3 class="text-left">4.  Bukit Salib, Lithuania </h3>
          <b-img :src="require('@/assets/img/articles/191017/Picture4.jpg')" class="content-picture" style="max-width: 70%;" />
          <p class="mt-4 text-justify">
            &emsp;Bukit Salib, adalah sebuah nama dari tempat ziarah di Lithuania Utara. Sejarah awalnya masih samar, karna menurut cerita rakyat dulunya di bukit ini ada gereja sampai suatu ketika ada badai menghampiri kilat menyambar gereja ini dan mengubur seluruh orang-orang yang masih berada didalam bersamaan dengan pasir dan batu yang berada dibukit. Tetapi cerita yang paling terkenal adalah tentang seorang ayah yang putus asa ketika anak perempuan nya mengalami sakit parah dan ketika anak perempuan nya sedang berada di ambang kematian datang seorang wanita yang menyuruhnya membuat tiang kayu dan meletakkannya di atas bukit terdekat; jika ia melakukannya maka anaknya akan sembuh. Sampai di pagi hari ia membuat salib kayu tersebut dan menancapkannya di bukit itu dan ketika bapak itu pulang kerumah,  putrinya telah menyambut di depan pintu dengan keadaan yang sudah baik-baik saja. Sejak saat itu orang-orang mulai menancapkan salib nya di bukit ini dengan harapan doa-doa mereka akan terkabul. Namun menurut laporan warga sekitar, banyak dari mereka yang melihat penampakan arwah biarawan sedang berjalan di bukit itu dan arwah orang-orang yang menjadi bagian dari sejarah bukit ini.
            </p>

          <p class="mt-3 text-justify">
            &emsp;Nah itu tadi beberapa tempat menyeramkan yang ada di Eropa, buat kalian yang suka wisata ekstrem cocok banget untuk kunjungi tempat-tempat ini, minimal sekali seumur hidup!
            </p>
        </b-col>
      </b-row>
    </b-container>

    <!-- mobile -->
    <b-container class="d-block d-sm-none" style="margin-top: -5em;">
      <b-row class="m-1 px-1 py-3 sg-rounded-container">
        <b-col cols="12" class="text-center">
          <h3>Tempat-tempat Menyeramkan Di Eropa</h3>
        </b-col>

        <b-col class="text-center">
          <p class="mt-3 text-justify">
            &emsp;Jika kita berbicara tentang tempat seram, maka tidak akan pernah ada habisnya. Selalu ada saja tempat-tempat yang sarat dengan misteri dan ceritanya sendiri. Mitos dan sejarah kelam yang telah beredar di kalangan masyarakat pun membuat tempat-tempat ini semakin membuat tempat ini semakin terasa menyeramkan.
          </p>
          <p class="mt-3 text-justify">
            &emsp;Berikut ini StarGuides akan memberikan beberapa lokasi mengerikan yang ada di Eropa:
          </p>

          <h5 class="text-left">1.  Les Catacombes, Paris</h5>
          <b-img :src="require('@/assets/img/articles/191017/Picture1.jpg')" fluid class="content-picture" />
          <p class="mt-4 text-justify">
            &emsp;Siapa sangka di balik indahnya dan terkenalnya Paris sebagai pusat rumah mode di dunia ini ternyata kota ini menyimpan satu tempat menyeramkan yang tidak banyak orang tahu. Di bagian selatan kota, terdapat kuburan bawah tanah yang luasnya sekitar 300 meter dan terbesar di dunia yang menyimpan sekitar 6 juta tengkorak manusia yang disusun dengan rapih.
            <br>
            &emsp;Pada tahun 1800an salah satu pemakaman umum Les Innocents di tengah kota Paris sudah penuh dan mulai menyebarkan penyakit, sejak saat itu orang-orang meminta pemakaman untuk dipindahkan ke bawah tanah. Kemudian pada tahun 1900an tempat ini dibuka untuk umum dan menjadi tempat wisata baru bagi pecinta horror.
          </p>

          <h5 class="text-left">2.  Blutgasse, Vienna</h5>
          <b-img :src="require('@/assets/img/articles/191017/Picture2.jpg')" fluid class="content-picture" />
          <p class="mt-4 text-justify">
            &emsp;Di belakang Saint Stephen’s Cathedral, daerah tertua di kota Vienna, terdapat satu gang kecil bernama Blutgasse. “Blut” yang berarti darah, dan “Gasse” yang berarti gang dalam Bahasa Jerman.
            <br>
            &emsp;Tempat ini dijuluki Blutgasse karna dulunya mempunyai banyak sejarah seram salah satunya tentang dibunuhnya nya para Ksatria Templar pada tahun 1312 hingga darah pun memenuhi lokasi itu sampai gang ini menjadi salah satu jalan yang harus dilewati oleh para terpidana mati sebelum mereka di eksekusi. Meskipun gang ini berada di pusat kota, namun gang ini sangat sepi oleh pejalan kaki.
            <br>
            &emsp;Hal ini dikarenakan sejarah kelamnya yang membuat tempat ini enggan untuk dikunjungi.  Konon menurut laporan para warga sekitar mereka pernah melihat penampakan para Ksatria ini berjalan di malam hari.
          </p>

          <h5 class="text-left">3.  Bran Castle, Rumania</h5>
          <b-img :src="require('@/assets/img/articles/191017/Picture3.jpg')" fluid class="content-picture" />
          <p class="mt-4 text-justify">
            &emsp;Rumania juga mempunyai satu destinasi horror yang menjadi tujuan para wisatawan. Berada di Transylvania, terdapat satu istana yang sangat terkenal dan menjadi inspirasi nya cerita drakula bernama Bran Castle. Siapa yang tidak tahu tentang kisah drakula? Vampire yang suka menghisap darah manusia ini mengambil inspirasi dari tempat ini.
            <br>
            &emsp;Ditempati oleh raja Vlad III pada tahun 1400an, dia disebut sebagai raja Vlad Tepes atau Vlad Dracula yang artinya Vlad Sang Penyula. Ia sempat menjadi pahlawan yang berhasil melindungi Rumania dari pasukan Turki, namun ia juga menjadi raja yang sangat sadis pada masanya karna dia mempunyai hobi yang sangat mengerikan.
            <br>
            &emsp;Raja Vlad ini senang untuk membunuh orang-orang yang menentangnya dengan cara disula, atau menusukkan kayu yang tajam dari ujung bawah badan korban hingga menembus keatas. Oleh karna cerita nya yang sadis ini menjadi awal mula cerita drakula.
          </p>

          <h5 class="text-left">4.  Bukit Salib, Lithuania </h5>
          <b-img :src="require('@/assets/img/articles/191017/Picture4.jpg')" fluid class="content-picture" />
          <p class="mt-4 text-justify">
            &emsp;Bukit Salib, adalah sebuah nama dari tempat ziarah di Lithuania Utara. Sejarah awalnya masih samar, karna menurut cerita rakyat dulunya di bukit ini ada gereja sampai suatu ketika ada badai menghampiri kilat menyambar gereja ini dan mengubur seluruh orang-orang yang masih berada didalam bersamaan dengan pasir dan batu yang berada dibukit.
            <br>
            &emsp;Tetapi cerita yang paling terkenal adalah tentang seorang ayah yang putus asa ketika anak perempuan nya mengalami sakit parah dan ketika anak perempuan nya sedang berada di ambang kematian datang seorang wanita yang menyuruhnya membuat tiang kayu dan meletakkannya di atas bukit terdekat.
            <br>
            &emsp;Jika ia melakukannya maka anaknya akan sembuh. Sampai di pagi hari ia membuat salib kayu tersebut dan menancapkannya di bukit itu dan ketika bapak itu pulang kerumah,  putrinya telah menyambut di depan pintu dengan keadaan yang sudah baik-baik saja. Sejak saat itu orang-orang mulai menancapkan salib nya di bukit ini dengan harapan doa-doa mereka akan terkabul.
            <br>
            &emsp;Namun menurut laporan warga sekitar, banyak dari mereka yang melihat penampakan arwah biarawan sedang berjalan di bukit itu dan arwah orang-orang yang menjadi bagian dari sejarah bukit ini.
          </p>

          <p class="mt-4 text-justify">
            &emsp;Nah itu tadi beberapa tempat menyeramkan yang ada di Eropa, buat kalian yang suka wisata ekstrem cocok banget untuk kunjungi tempat-tempat ini, minimal sekali seumur hidup!
          </p>
        </b-col>
      </b-row>
    </b-container>

    <b-container class="mt-3" />
  </div>
</template>

<script>
// external dependencies

// custom component
import Jumbotron from '@/components/Jumbotron'

// api call

export default {
  name: 'Content_Article191017',
  components: {
    Jumbotron
  },
  data () {
    return {
    }
  },
  methods: {
    // PREREQUISITES
    // END PREREQUISITES

    // HTTP REQUEST
    // END HTTP REQUEST
  }
}
</script>

<style scoped>
.content-picture {
  box-shadow: 0px 10px 10px 0px rgba(0, 0, 0, 0.5);
  border-radius: 15px;
}
</style>



// WEBPACK FOOTER //
// src/views/Content/Article191017.vue